// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oTlS","title":"styles_title__1-wzV"};